var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('swiper-container',{attrs:{"space-between":15,"pagination":{ clickable: true },"breakpoints":_setup.sliderConfig.breakpoints}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }